/** @jsxImportSource @emotion/react */
"use client";

import type { HallowElementProps } from "@packages/ui";
import { CloseIcon, colors, emotionDynamics, IconButton } from "@packages/ui";
import { Close as DialogClose } from "@radix-ui/react-dialog";
import { Button as ToolbarButton } from "@radix-ui/react-toolbar";
import { HallowDataTestId } from "@tools/playwright/global";
import type { MouseEventHandler } from "react";

export type CloseButtonProps = HallowElementProps<"button"> & {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const CloseButton = ({ onClick, className = "" }: CloseButtonProps) => (
  <ToolbarButton asChild>
    <DialogClose asChild>
      <IconButton
        icon={<CloseIcon fill={colors.white} />}
        variant={"transparentWhite"}
        data-testid={HallowDataTestId.MediaClose}
        onClick={onClick}
        css={emotionDynamics.hideDesktopViewport("flex")}
        className={className}
        tabIndex={0}
      />
    </DialogClose>
  </ToolbarButton>
);
